import {
  faRocket,
  faPlayCircle,
  faPen,
  faShareNodes,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Central configuration for shared strategy action buttons.
 * Each action defines the default label, icon, and visual tokens.
 */
export const STRATEGY_ACTIONS = {
  startTrading: {
    key: 'startTrading',
    label: 'Start Trading',
    icon: faRocket,
    role: 'primary',
    colors: {
      background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
      backgroundHover: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      border: '1px solid rgba(5, 150, 105, 0.35)',
      borderHover: '1px solid rgba(5, 150, 105, 0.55)',
      boxShadow: '0 6px 18px rgba(5, 150, 105, 0.35)',
      boxShadowHover: '0 10px 26px rgba(5, 150, 105, 0.45)',
      textColor: '#ffffff',
    },
  },
  runBacktest: {
    key: 'runBacktest',
    label: 'Run Backtest',
    icon: faPlayCircle,
    role: 'secondary',
    colors: {
      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
      backgroundHover: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      border: '1px solid rgba(37, 99, 235, 0.35)',
      borderHover: '1px solid rgba(59, 130, 246, 0.5)',
      boxShadow: '0 4px 14px rgba(37, 99, 235, 0.35)',
      boxShadowHover: '0 6px 20px rgba(37, 99, 235, 0.45)',
      textColor: '#ffffff',
    },
  },
  editStrategy: {
    key: 'editStrategy',
    label: 'Edit Strategy',
    icon: faPen,
    role: 'accent',
    colors: {
      background:
        'var(--bsui-ai-action-background, linear-gradient(135deg, #f97316 0%, #fb923c 100%))',
      backgroundHover:
        'var(--bsui-ai-action-background-hover, linear-gradient(135deg, #fb923c 0%, #f97316 100%))',
      border: 'var(--bsui-ai-action-border, 1px solid rgba(249, 115, 22, 0.35))',
      borderHover: 'var(--bsui-ai-action-border-hover, 1px solid rgba(251, 146, 60, 0.5))',
      boxShadow: 'var(--bsui-ai-action-shadow, 0 4px 14px rgba(249, 115, 22, 0.3))',
      boxShadowHover: 'var(--bsui-ai-action-shadow-hover, 0 6px 20px rgba(249, 115, 22, 0.4))',
      textColor: 'var(--bsui-ai-action-text, #ffffff)',
    },
  },
  shareStrategy: {
    key: 'shareStrategy',
    label: 'Share',
    icon: faShareNodes,
    role: 'accent',
    colors: {
      background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      backgroundHover: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
      border: '1px solid rgba(139, 92, 246, 0.3)',
      borderHover: '1px solid rgba(167, 139, 250, 0.45)',
      boxShadow: '0 4px 14px rgba(139, 92, 246, 0.3)',
      boxShadowHover: '0 6px 20px rgba(139, 92, 246, 0.4)',
      textColor: '#ffffff',
    },
  },
};

/**
 * Helper to safely retrieve action configuration.
 */
export function getStrategyActionConfig(actionType) {
  return STRATEGY_ACTIONS[actionType] || null;
}

/**
 * Shared size presets expressed as CSS variable overrides.
 * These are consumed by StrategyActionButton to keep typography uniform.
 */
export const STRATEGY_ACTION_SIZES = {
  hero: {
    '--sa-font-size': '1.2rem',
    '--sa-font-weight': '700',
    '--sa-padding-y': '18px',
    '--sa-padding-x': '36px',
    '--sa-border-radius': '16px',
    '--sa-min-height': '60px',
    '--sa-icon-size': '1.25rem',
    '--sa-gap': '12px',
    '--sa-letter-spacing': '0.5px',
    '--sa-text-transform': 'uppercase',
  },
  large: {
    '--sa-font-size': '1.05rem',
    '--sa-font-weight': '700',
    '--sa-padding-y': '14px',
    '--sa-padding-x': '26px',
    '--sa-border-radius': '14px',
    '--sa-min-height': '52px',
    '--sa-icon-size': '1.1rem',
  },
  medium: {
    '--sa-font-size': '1rem',
    '--sa-font-weight': '600',
    '--sa-padding-y': '12px',
    '--sa-padding-x': '20px',
    '--sa-border-radius': '12px',
    '--sa-min-height': '48px',
    '--sa-icon-size': '1.05rem',
  },
  compact: {
    '--sa-font-size': '0.95rem',
    '--sa-font-weight': '600',
    '--sa-padding-y': '10px',
    '--sa-padding-x': '16px',
    '--sa-border-radius': '10px',
    '--sa-min-height': '42px',
    '--sa-icon-size': '1rem',
    '--sa-gap': '8px',
  },
};
